export default __webpack_public_path__ + "static/media/payment-info-1x.5f0b3efa.png";